import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { WorkspaceSettingsPages } from "@components/settings/constants";
import { useDocumentInboxSettingsLabel } from "@components/settings/WorkspaceReceipts/useCanShowBillInvoiceInbox";
import { SettingsDropdownItem } from "./SettingsDropdownItem";

export const WorkspaceSettingsItems: React.FC = () => {
    const documentInboxLabel = useDocumentInboxSettingsLabel();

    return (
        <Menu.Group>
            <Menu.GroupLabel>Workspace</Menu.GroupLabel>
            <SettingsDropdownItem path={WorkspaceSettingsPages.MEMBERS}>
                Members
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.TASK_GROUPS}>
                Task groups
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.INTEGRATIONS}>
                Integrations
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.LOCKS}>
                Locks
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.ACCOUNTING}>
                Accounting
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.PLANS}>
                Plans
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.BILLING}>
                Billing
            </SettingsDropdownItem>
            <SettingsDropdownItem
                path={WorkspaceSettingsPages.BILLING_TRANSFER}
            >
                Billing
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.DOCUMENT_INBOX}>
                {documentInboxLabel}
            </SettingsDropdownItem>
            <SettingsDropdownItem path={WorkspaceSettingsPages.SENDING_DOMAINS}>
                Sending domains
            </SettingsDropdownItem>
        </Menu.Group>
    );
};
